const Ecadia = () => import(/* webpackChunkName: "Ecadia" */ "@/views/ecadia/Ecadia");
const EcadiaList = () => import(/* webpackChunkName: "Ecadia List" */ "@/views/ecadia/EcadiaList");
const EcadiaEdit = () => import(/* webpackChunkName: "Ecadia Edit" */ "@/views/ecadia/EcadiaEdit");

const ecadiaRoutes = [
  {
    path: "ecadia",
    name: "Ecadia",
    redirect: {
      name: "Ecadia List"
    },
    component: Ecadia,
    children: [
      {
        path: "list",
        name: "Ecadia List",
        component: EcadiaList
      },
      {
        path: "edit/:id",
        name: "Ecadia Edit",
        component: EcadiaEdit,
        props: true
      }
    ]
  }
];

export default ecadiaRoutes;